import { render } from "./TableStylePanel.vue?vue&type=template&id=2db32cac&scoped=true&ts=true"
import script from "./TableStylePanel.vue?vue&type=script&lang=ts"
export * from "./TableStylePanel.vue?vue&type=script&lang=ts"

import "./TableStylePanel.vue?vue&type=style&index=0&id=2db32cac&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db32cac"]])

export default __exports__